import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

function TrialLogin() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Setting up your trial...');

  useEffect(() => {
    const token = searchParams.get('token');
    const userStr = searchParams.get('user');
    const password = searchParams.get('password');

    if (token && userStr) {
      try {
        // Store the token — AuthContext will pick it up
        localStorage.setItem('token', token);

        // Show the temp password briefly so they can log in again later
        const user = JSON.parse(userStr);
        setMessage(`Welcome, ${user.full_name}! Your trial is active.`);

        // Store temp password in sessionStorage so we can show it once
        if (password) {
          sessionStorage.setItem('trial_password', password);
          sessionStorage.setItem('trial_email', user.email);
        }

        // Redirect to home after a brief moment
        setTimeout(() => {
          window.location.href = '/';
        }, 1000);

      } catch (e) {
        setMessage('Something went wrong. Please try again.');
      }
    } else {
      setMessage('Invalid trial link. Please go back and try again.');
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-[#0A0E27] flex items-center justify-center px-4 py-8">
      <div className="text-center">
        <div className="text-blue-400 text-xl mb-4">{message}</div>
        <div className="text-[#546E7A] text-sm">Redirecting to SchemeSync HS...</div>
      </div>
    </div>
  );
}

export default TrialLogin;
